import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetUser } from 'selectors/users';

import { isTempId } from 'utils/helpers';
import { useCanUser } from 'shared-hooks/permission';

import CanUser from 'components/can-user';
import LabelPicker from 'components/label-picker';
import LabelsList from 'components/labels-list';

import IconPlus from 'icons/icon-plus';

import './UserLabels.styles.css';

const EMPTY_ARRAY = [];

const UserLabels = ({ id, role, labels, onAdd, onRemove, t }) => {
    const canViewUserLabels = useCanUser('viewUserLabels');
    const canViewClientUserLabels = useCanUser('viewClientUserLabels');

    const handleAdd = useCallback(labelId => {
        onAdd(labelId);
    }, [onAdd]);

    const handleRemove = useCallback(labelId => {
        onRemove(labelId);
    }, [onRemove]);

    const isTemp = useMemo(() => isTempId(id), [id]);

    if (isTemp) {
        return null;
    }
    return (
        <React.Fragment>
            <CanUser type="editUser">
                <LabelPicker
                    userId={id}
                    assignedLabels={labels}
                    xAlign="left"
                    defaultXPosition="right"
                    onAdd={onAdd && handleAdd}
                    onRemove={onRemove && handleRemove}
                >
                    <div className="user-labels">
                        <LabelsList labels={labels} inverted={true}>

                        <span className="labels-list-item placeholder">
                            <span className="placeholder-inner">
                                <IconPlus />

                                <span className="placeholder-text">{ t('Tag') }</span>
                            </span>
                        </span>
                        </LabelsList>
                    </div>
                </LabelPicker>
            </CanUser>

            {
                (role === 'client' && canViewClientUserLabels) ||
                (role !== 'client' && canViewUserLabels) ?
                    <CanUser type="editUser" reverse={true}>
                        <div className="user-labels">
                            <LabelsList labels={labels} inverted={true} />
                        </div>
                    </CanUser>
                : null
            }
        </React.Fragment>
    );
};

const makeMapStateToProps = () => {
    const getUser = makeGetUser();

    return ({ users }, ownProps) => {
        const user = getUser(users, ownProps.id);

        return {
            role: user?.role,
            labels: user?.labels || EMPTY_ARRAY
        }
    }
}

export default connect(makeMapStateToProps)(withTranslation('labels')(React.memo(UserLabels)));
